import { render } from "./Mo_modal_l.vue?vue&type=template&id=38f13015&scoped=true&ts=true"
import script from "./Mo_modal_l.vue?vue&type=script&lang=ts"
export * from "./Mo_modal_l.vue?vue&type=script&lang=ts"

import "./Mo_modal_l.vue?vue&type=style&index=0&id=38f13015&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f13015"]])

export default __exports__